import React, { useState } from 'react';
import { Dropdown, Menu, Tooltip, Icon } from 'antd';
import cn from 'classnames';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { requestActionNames } from '../../constants/common';
import styles from './ActionsDropdown.module.scss';

const items = [
  { id: requestActionNames.excel, name: 'Выгрузить в excel' },
  { id: requestActionNames.print, name: 'Отправить на печать' },
];

const ActionsDropdown = ({ className, disabled, onMenuClick }) => {
  const [visible, setVisible] = useState(false);

  const handleMenuClick = ({ key }) => {
    onMenuClick(key);
    setVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  return (
    <Dropdown
      overlay={
        <Menu selectable={false} onClick={handleMenuClick}>
          {items.map((item) => (
            <Menu.Item key={item.id}>{item.name}</Menu.Item>
          ))}
        </Menu>
      }
      trigger={['click']}
      disabled={disabled}
      onVisibleChange={handleVisibleChange}
      visible={visible}
    >
      <Tooltip title={disabled ? 'Сначала выберите заявки' : ''}>
        <RoundedButton
          iconRight={<Icon type="caret-down" />}
          text="Действия"
          className={cn(styles.root, className)}
          type={disabled ? 'default' : 'secondary'}
          invert
        />
      </Tooltip>
    </Dropdown>
  );
};

export default ActionsDropdown;
